// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__5PuMt","boxTitle":"Qualiphy_boxTitle__2Guca","box":"Qualiphy_box__2jdvg","toggleWrap":"Qualiphy_toggleWrap__2y3fE"};